/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevenueMonthData } from './RevenueMonthData';
import {
    RevenueMonthDataFromJSON,
    RevenueMonthDataFromJSONTyped,
    RevenueMonthDataToJSON,
    RevenueMonthDataToJSONTyped,
} from './RevenueMonthData';

/**
 * 
 * @export
 * @interface WidgetDataRevenueHistoryWidgetData
 */
export interface WidgetDataRevenueHistoryWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataRevenueHistoryWidgetData
     */
    $type?: WidgetDataRevenueHistoryWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<RevenueMonthData>}
     * @memberof WidgetDataRevenueHistoryWidgetData
     */
    months: Array<RevenueMonthData>;
}


/**
 * @export
 */
export const WidgetDataRevenueHistoryWidgetDataTypeEnum = {
    RevenueHistory: 'revenue-history'
} as const;
export type WidgetDataRevenueHistoryWidgetDataTypeEnum = typeof WidgetDataRevenueHistoryWidgetDataTypeEnum[keyof typeof WidgetDataRevenueHistoryWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataRevenueHistoryWidgetData interface.
 */
export function instanceOfWidgetDataRevenueHistoryWidgetData(value: object): value is WidgetDataRevenueHistoryWidgetData {
    if (!('months' in value) || value['months'] === undefined) return false;
    return true;
}

export function WidgetDataRevenueHistoryWidgetDataFromJSON(json: any): WidgetDataRevenueHistoryWidgetData {
    return WidgetDataRevenueHistoryWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataRevenueHistoryWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataRevenueHistoryWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'months': ((json['months'] as Array<any>).map(RevenueMonthDataFromJSON)),
    };
}

export function WidgetDataRevenueHistoryWidgetDataToJSON(json: any): WidgetDataRevenueHistoryWidgetData {
    return WidgetDataRevenueHistoryWidgetDataToJSONTyped(json, false);
}

export function WidgetDataRevenueHistoryWidgetDataToJSONTyped(value?: WidgetDataRevenueHistoryWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'months': ((value['months'] as Array<any>).map(RevenueMonthDataToJSON)),
    };
}

